import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import * as firebase from 'firebase';
import {Link} from 'react-router';
import './Orders.css';
const { Toolbar, Filters: { NumericFilter, AutoCompleteFilter }, Data: { Selectors } } = require('react-data-grid-addons');
import moment from 'moment-es6'
import { camelCaseToRegularCase } from './utils/helper'
//TODO
// (1)
// Enable grouping
// http://adazzle.github.io/react-data-grid/examples.html#/grouping
// (2)
// Show time since the order
//

class StatusColorFormatter extends Component {
  constructor(props) {
    super(props);
    this.colorMap = {
      'received': '#ccccff',
      'onhold': '#ffebcc',
      'completed': '#9fdf9f',
      'dispatched': '#9fdf9f',
      'cancelled': '#ffb399',
      'pending': 'darkorange',
      'approved': 'lightgreen',
      'pending_approval': 'orange',
      paid: 'darkgreen',
      printed: 'blue',
      rejected: '#e74c3c',
      partial_paid: '#1abc9c',
      paid: '#16a085'
    }
  }
  render() {
    return (
      <div style={this.getStatusColor()}>
        { this.props.value }
      </div>
    );
  }

  getStatusColor() {
    return {
      backgroundColor: this.colorMap[this.props.value],
      textAlign: 'center',
      padding: '4px',
      textTransform: 'uppercase',
      borderRadius: 8,
      padding: '2px 0.5em',
      color: 'white'
    };
  }
}


class OrderLinkFormatter extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Link to={`/order/${this.props.value}`}>{ this.props.value }</Link>
      </div>
    );
  }
}


const DateFormatter = (p) => {
  const m = moment(p.value, 'YYYY-MM-DD HH:mm:ssA');
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <p>{m.format('DD/MMM/YY - HH:mm:ssA')}<span style={{fontSize: '0.6em', color: 'darkgray'}}>({m.fromNow()})</span></p>
    </div>
  )
}

const ProductFormatter = (p) => {
  return (
    <div className="capitalize">{camelCaseToRegularCase(p.value)}</div>
  );
}

const PriceFormatter = (p) => {
  const num = parseFloat(p.value);
  if (isNaN(num)) {
    return (<div>-</div>);
  }
  return (
    <div>₹{num.toLocaleString('en-IN', { minimumFractionDigits: 2 })}</div>
  );
}

const WeightFormatter = (p) => {
  const num = parseFloat(p.value);
  if (isNaN(num)) {
    return (<div>-</div>);
  }
  return (
    <div>{num.toLocaleString('en-IN', { maximumFractionDigits: 3 })} tons</div>
  );
}


class Orders extends Component {

  constructor(props) {
    super(props);

    const db = firebase.database();

    this.data = {
      dbRef: db.ref()
    }

    let _defaultRows = [];
    this._columns = [
      {
        key: 'id',
        name: 'ORDER ID',
        resizable: true,
        sortable: true,
        width: 200,
        filterable:true,
        locked: true,
        formatter: OrderLinkFormatter
      },
      {
        key: 'ts',
        name: 'DATE',
        resizable: true,
        sortable: true,
        filterable:true,
        formatter: DateFormatter
      },
      {
        key: 'agent',
        name: 'Agent ',
        resizable: true,
        sortable: true,
        filterable:true,
        minWidth: 200
      },
      {
        key: 'partyDetails',
        name: 'Party',
        resizable: true,
        sortable: true,
        minWidth: 200,
        filterable:true
      },
      {
        key: 'product',
        name: 'PRODUCT',
        resizable: true,
        sortable: true,
        minWidth: 150,
        filterable:true,
        formatter: ProductFormatter
      },
      {
        key: 'agentPrice',
        name: 'AGENT PRICE',
        resizable: true,
        sortable: true,
        minWidth: 150,
        filterable:true,
        formatter: PriceFormatter
      },
      {
        key: 'quantityInTons',
        name: 'TOTAL WEIGHT',
        resizable: true,
        sortable: true,
        minWidth: 150,
        filterable:true,
        formatter: WeightFormatter
      },
      {
        key: 'area',
        name: 'AREA',
        resizable: true,
        sortable: true,
        minWidth: 200,
        filterable:true
      },
      {
        key: 'status',
        name: 'STATUS',
        resizable: true,
        sortable: true,
        minWidth: 200,
        filterable:true,
        formatter: StatusColorFormatter
      },

    ];
    this.defaultState = {
      name: '',
      lastUpdated: '',
      rows: _defaultRows,
      filters: {},
      fromDate: '',
      toDate: ''
    };


    this.state = {
      ...this.defaultState,
      currentPage: 1,
      rowsPerPage: 100
    };
  }

  getVisibleRows = () => {
    const baseRows = Selectors.getRows(this.state) || [];
    const { fromDate, toDate } = this.state;

    if (!fromDate && !toDate) return baseRows;

    // Parse dates in DD/MM/YYYY format (Indian date format)
    const from = fromDate ? moment(fromDate, 'DD/MM/YYYY').startOf('day') : null;
    const to = toDate ? moment(toDate, 'DD/MM/YYYY').endOf('day') : null;

    const parseRowMoment = (row) => {
      if (row && row.ts) {
        const m = moment(row.ts, 'YYYY-MM-DD HH:mm:ssA', true);
        if (m.isValid()) return m;
      }
      if (row && row.time) {
        const num = Number(row.time);
        if (!isNaN(num)) return moment(num);
      }
      return null;
    };

    return baseRows.filter(r => {
      const m = parseRowMoment(r);
      if (!m) return false;
      if (from && m.isBefore(from)) return false;
      if (to && m.isAfter(to)) return false;
      return true;
    });
  }

  // Convert date from YYYY-MM-DD to DD/MM/YYYY format
  formatDateToIndian = (dateStr) => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
  }

  // Convert date from DD/MM/YYYY to YYYY-MM-DD format
  formatDateFromIndian = (dateStr) => {
    if (!dateStr) return '';
    const [day, month, year] = dateStr.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  // Validate Indian date format
  isValidIndianDate = (dateStr) => {
    if (!dateStr) return true;
    const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = dateStr.match(regex);
    if (!match) return false;
    
    const day = parseInt(match[1]);
    const month = parseInt(match[2]);
    const year = parseInt(match[3]);
    
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1900 || year > 2100) {
      return false;
    }
    
    // Check if the date is valid
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  }

  // Get row background color based on status
  getRowBackgroundColor = (row) => {
    const status = row.status;
    const colorMap = {
      'received': 'rgba(204, 204, 255, 0.15)',      // Light blue tint
      'onhold': 'rgba(255, 235, 204, 0.15)',        // Light orange tint
      'completed': 'rgba(159, 223, 159, 0.15)',     // Light green tint
      'dispatched': 'rgba(159, 223, 159, 0.15)',    // Light green tint
      'cancelled': 'rgba(255, 179, 153, 0.15)',     // Light red tint
      'pending': 'rgba(255, 140, 0, 0.15)',         // Light dark orange tint
      'approved': 'rgba(144, 238, 144, 0.15)',      // Light green tint
      'pending_approval': 'rgba(255, 165, 0, 0.15)', // Light orange tint
      'paid': 'rgba(0, 100, 0, 0.15)',              // Light dark green tint
      'printed': 'rgba(0, 0, 255, 0.15)',           // Light blue tint
      'rejected': 'rgba(231, 76, 60, 0.15)',        // Light red tint
      'partial_paid': 'rgba(26, 188, 156, 0.15)',   // Light teal tint
    };
    
    return colorMap[status] || 'transparent';
  }

  // Custom row renderer with background color
  getRowStyle = (row) => {
    return {
      backgroundColor: this.getRowBackgroundColor(row)
    };
  }

  // Get CSS class name based on status
  getRowClassName = (row) => {
    const status = row.status;
    return `order-row-${status}`;
  }

  // Handle from date change with auto-setting to date
  handleFromDateChange = (e) => {
    const inputValue = e.target.value;
    let fromDate = inputValue;
    
    // If it's a date picker input (YYYY-MM-DD), convert to Indian format
    if (e.target.type === 'date') {
      fromDate = this.formatDateToIndian(inputValue);
    }
    
    const newState = { fromDate };
    
    // If from date is selected and to date is not set, auto-set to date to same day
    if (fromDate && !this.state.toDate && this.isValidIndianDate(fromDate)) {
      newState.toDate = fromDate;
    }
    
    this.setState(newState, () => {
      // Apply row styling after date filter change
      this.applyRowStyling();
    });
  }

  // Handle to date change
  handleToDateChange = (e) => {
    const inputValue = e.target.value;
    let toDate = inputValue;
    
    // If it's a date picker input (YYYY-MM-DD), convert to Indian format
    if (e.target.type === 'date') {
      toDate = this.formatDateToIndian(inputValue);
    }
    
    this.setState({ toDate }, () => {
      // Apply row styling after date filter change
      this.applyRowStyling();
    });
  }

  downloadOrdersCsv = () => {
    const visibleRows = this.getVisibleRows() || [];
    const columnDefs = (this._columns || []).filter(c => !!c && !!c.key);

    if (!visibleRows.length) {
      alert('No orders to export');
      return;
    }

    const headers = columnDefs.map(c => c.name || c.key);
    const escapeCsv = (val) => {
      if (val === undefined || val === null) return '';
      const s = String(val);
      if (s.includes('"') || s.includes(',') || s.includes('\n')) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    };

    const valueFor = (row, key) => {
      const v = row[key];
      if (key === 'product') {
        return camelCaseToRegularCase(v);
      }
      return v;
    };

    const lines = [];
    lines.push(headers.join(','));
    visibleRows.forEach(row => {
      const fields = columnDefs.map(c => escapeCsv(valueFor(row, c.key)));
      lines.push(fields.join(','));
    });

    const csvContent = '\uFEFF' + lines.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'orders.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }

  // Apply status-based CSS classes to rows
  applyRowStyling = () => {
    setTimeout(() => {
      const rows = document.querySelectorAll('.react-grid-Row');
      const visibleRows = this.getVisibleRows();
      
      rows.forEach((rowElement, index) => {
        // Skip header row
        if (index === 0) return;
        
        const dataIndex = index - 1;
        if (visibleRows[dataIndex]) {
          const row = visibleRows[dataIndex];
          const statusClass = this.getRowClassName(row);
          
          // Remove existing status classes
          rowElement.className = rowElement.className.replace(/order-row-\w+/g, '');
          
          // Add new status class
          if (statusClass) {
            rowElement.classList.add(statusClass);
          }
        }
      });
    }, 100); // Small delay to ensure DOM is updated
  }

  componentDidMount() {
    //code to add allowed areas

    // console.log('###################');
    // const shopsRef = this.data.dbRef.child('users');
    // shopsRef.once('value', data => {
    // //  console.log(data.val());
    //   let usersObj = data.val();
    //   let keys = Object.keys(usersObj);
    //   keys.map(k => {
    //     console.log('key = = ', k);
    //     if(usersObj[k].shops) {
    //       //console.log('value # # ',  usersObj[k].shops);
    //       let allShops = usersObj[k].shops;
    //       let allAreas=[];
    //       Object.keys(allShops).map(index => {
    //       //  console.log('shop = =', allShops[index]);
    //         allAreas.push(allShops[index].areaId);
    //       })
    //       let unique = allAreas.filter((v, i, a) => a.indexOf(v) === i);
    //     //  console.log('all unique areas = = = ', unique);
    //       let areasObj = {};
    //       unique.forEach((item,index) => {
    //       //  console.log(index, item);
    //         areasObj[index]=item;
    //       })
    //       console.log('areas = = ', areasObj);
    //       const areasRef = this.data.dbRef.child('users/' + k +   '/allowedAreas');
    //       areasRef.set(areasObj);
    //
    //
    //
    //     }
    //
    //   })
    // });

    const that = this;
    const ordersRef = this.data.dbRef.child('o');
    ordersRef.orderByChild('priority').limitToFirst(1200).on('value', snapshot => {
      let tablerows = [];
      let orders = snapshot.val();
      for(let orderId in orders){
        const order = orders[orderId];
        const agentName = order.agent.name || order.agent;
        delete order.agent;
        let dateTime = new Date(Number(order.time));
        let formattedDate = dateTime.toLocaleDateString('en-IN') + ' ' + dateTime.toLocaleTimeString('en-IN');

        tablerows.unshift({...order, agent: agentName})
      }
      that.setState({
         rows: tablerows.sort((a,b) => {return (a.priority < b.priority) ? 1 : ((b.priority < a.priority) ? -1 : 0);} )
      }, () => {
        // Apply row styling after state update
        that.applyRowStyling();
      })
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Apply row styling when data changes
    if (prevState.rows !== this.state.rows || 
        prevState.fromDate !== this.state.fromDate || 
        prevState.toDate !== this.state.toDate ||
        prevState.filters !== this.state.filters) {
      this.applyRowStyling();
    }
  }


  rowGetter(i) {
    const { currentPage, rowsPerPage } = this.state;
    const startIndex = (currentPage - 1) * rowsPerPage;
    return this.getVisibleRows()[startIndex + i];
  }

  rowsCount() {
    const { currentPage, rowsPerPage } = this.state;
    const startIndex = (currentPage - 1) * rowsPerPage;
    return Math.min(this.getVisibleRows().length - startIndex, rowsPerPage);
  }

  handleFilterChange(filter) {
    let newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters }, () => {
      // Apply row styling after filtering
      this.applyRowStyling();
    });
  }

  getValidFilterValues(columnId) {
   let values = this.state.rows.map(r => r[columnId]);
   return values.filter((item, i, a) => { return i === a.indexOf(item); });
  }

  handleOnClearFilters() {
    this.setState({filters: {} }, () => {
      // Apply row styling after clearing filters
      this.applyRowStyling();
    });
  }

  handleGridSort(sortColumn, sortDirection) {
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
      }
    };

    const newRows = sortDirection === 'NONE' ? this.state.rows.slice(0) : this.state.rows.sort(comparer);
    this.setState({rows : newRows}, () => {
      // Apply row styling after sorting
      this.applyRowStyling();
    });
  }

  handlePageChange = (newPage) => {
    this.setState({
        currentPage: newPage
    });
  }

  handlePageSizeChange = (e) => {
    this.setState({
        rowsPerPage: parseInt(e.target.value),
        currentPage: 1
    });
  }

  componentWillUnmount() {
  }

  render() {
    return (
      <div tabTitle="Orders" className="py-8 mx-8 mx-auto">
        <h1 className='text-3xl text-green-600 text-center mx-auto'>Purchase Orders</h1>
        <div className='w-full py-2 px-4'>
          <a href='/archived-orders'><button className='bg-blue-600 text-white px-3 py-1 rounded'>Show Older Orders</button></a>
          <a href='/purge'><button className='bg-red-600 text-white px-3 py-1 rounded ml-4'>Archive Old Orders</button></a>
          <div className='inline-flex items-center ml-4'>
            <label className='mr-2 text-sm text-gray-700'>From:</label>
            <div className='date-input-container mr-4'>
              <input
                type='text'
                value={this.state.fromDate}
                onChange={this.handleFromDateChange}
                placeholder='dd/mm/yyyy'
                pattern='\d{1,2}/\d{1,2}/\d{4}'
                className={`border rounded px-2 py-1 pr-8 ${!this.isValidIndianDate(this.state.fromDate) && this.state.fromDate ? 'border-red-500' : ''}`}
              />
              <input
                type='date'
                value={this.formatDateFromIndian(this.state.fromDate)}
                onChange={this.handleFromDateChange}
                className='absolute top-0 right-0 w-6 h-full opacity-0 cursor-pointer'
                title='Click to open date picker'
              />
            </div>
            <label className='mr-2 text-sm text-gray-700'>To:</label>
            <div className='date-input-container mr-4'>
              <input
                type='text'
                value={this.state.toDate}
                onChange={this.handleToDateChange}
                placeholder='dd/mm/yyyy'
                pattern='\d{1,2}/\d{1,2}/\d{4}'
                className={`border rounded px-2 py-1 pr-8 ${!this.isValidIndianDate(this.state.toDate) && this.state.toDate ? 'border-red-500' : ''}`}
              />
              <input
                type='date'
                value={this.formatDateFromIndian(this.state.toDate)}
                onChange={this.handleToDateChange}
                className='absolute top-0 right-0 w-6 h-full opacity-0 cursor-pointer'
                title='Click to open date picker'
              />
            </div>
            <button onClick={this.downloadOrdersCsv} className='bg-blue-600 text-white px-3 py-1 rounded'>Download CSV</button>
          </div>
        </div>
        <ReactDataGrid
          columns={this._columns}
          rowGetter={this.rowGetter.bind(this)}
          rowsCount={this.rowsCount()}
          onGridSort={this.handleGridSort.bind(this)}
          toolbar={<Toolbar enableFilter={true}/>}
          onAddFilter={this.handleFilterChange.bind(this)}
          getValidFilterValues={this.getValidFilterValues}
          onClearFilters={this.handleOnClearFilters}
          minHeight={this.rowsCount()*37+40}
        />
        <div className="py-4 flex justify-between items-center">
            <div>
                <span>Page {this.state.currentPage} of {Math.ceil(this.getVisibleRows().length / this.state.rowsPerPage)}</span>
            </div>
            <div>
                <select onChange={this.handlePageSizeChange} value={this.state.rowsPerPage} className="border rounded px-2 py-1 ml-4">
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                </select>
            </div>
            <div>
                <button
                    onClick={() => this.handlePageChange(this.state.currentPage - 1)}
                    disabled={this.state.currentPage === 1}
                    className="bg-gray-300 px-3 py-1 rounded mr-2"
                >
                    Previous
                </button>
                <button
                    onClick={() => this.handlePageChange(this.state.currentPage + 1)}
                    disabled={this.state.currentPage === Math.ceil(this.getVisibleRows().length / this.state.rowsPerPage)}
                    className="bg-gray-300 px-3 py-1 rounded"
                >
                    Next
                </button>
            </div>
        </div>
        <footer>© MRP Solutions 2017</footer>
      </div>
    );
  }
}

export default Orders;



/** WEBPACK FOOTER **
 ** ./src/Orders.js
 **/